<template>
  <div class="transaction-totals">
    <div v-if="totals.total"
         class="text-xl font-bold text-text leading-tight"
         v-tooltip="tooltip ? popup : false"
         :style="tooltip ? 'cursor:help':''">
      {{ $t('total') }} {{ displayCurrencyValue(totals.total, spaceCurrency) }}
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "TransactionsTotal",
  props: {
    totals: {
      type: Object
    },
    tooltip: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    ...mapGetters('space', ['spaceCurrency']),
    popup() {
      return `
        ${!!this.totals.totalIncome ? `<div>${this.$t('incomes')} ${this.displayCurrencyValue(this.totals.totalIncome, this.spaceCurrency)}</div>` : ''}
        ${!!this.totals.totalExpense ? `<div>${this.$t('expenses')} ${this.displayCurrencyValue(this.totals.totalExpense, this.spaceCurrency)}</div>` : ''}
        ${!!this.totals.totalTransfers ? `<div>${this.$t('transfers')} ${this.displayCurrencyValue(this.totals.totalTransfers, this.spaceCurrency)}</div>` : ''}`
    }
  },
  i18n: {
    messages: {
      en: {
        incomes: 'Incomes',
        expenses: 'Expenses',
        transfers: 'Transfers',
        total: 'Total'
      },
      ru: {
        incomes: 'Доходы',
        expenses: 'Расходы',
        transfers: 'Обмены',
        total: 'Итог'
      }
    }
  }
}
</script>